import { Stack } from "@mui/material";
import { ValueItems } from "Components/Shared/ValuesBox/ValueItems";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { Gender, type PartyDto } from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";

type Props = {
  beneficialOwner: Partial<PartyDto>;
};

export const BeneficialOwnerDetail = ({
  beneficialOwner: {
    addresses,
    firstName,
    lastName,
    gender,
    birthDate,
    nationality,
    isForeigner,
  },
}: Props) => {
  const { t } = useResource();
  const { getCountryName } = useCountryNameResolver();

  const address = addresses?.[0];
  const nationalityValue =
    getCountryName(nationality) || t(Resources.Common.Unknown);
  const genderValue = t(
    Resources.Form.PersonalData.Sex[gender ?? Gender.NotSet],
  );
  const isForeignerValue = isForeigner
    ? t(Resources.Common.Yes)
    : t(Resources.Common.No);

  return (
    <Stack gap={2}>
      <ValuesBox title={t(Resources.Common.BeneficialOwner.Title)}>
        <ValueItems
          values={[
            {
              label: t(Resources.Common.BeneficialOwner.Name),
              value: firstName,
            },
            {
              label: t(Resources.Common.BeneficialOwner.LastName),
              value: lastName,
            },
            {
              label: t(Resources.Common.BeneficialOwner.Gender),
              value: genderValue,
            },
            {
              label: t(Resources.Common.BeneficialOwner.BirthDate),
              value: formatDate(birthDate),
            },
            {
              label: t(Resources.Common.BeneficialOwner.Nationality),
              value: nationalityValue,
            },
            {
              label: t(Resources.Common.BeneficialOwner.IsForeigner),
              value: isForeignerValue,
            },
          ]}
        />
      </ValuesBox>
      <ValuesBox title={t(Resources.Common.Address.Title)}>
        <ValueItems
          values={[
            {
              label: t(Resources.Common.Address.Street),
              value: address?.street,
            },
            {
              label: t(Resources.Common.Address.StreetNumber),
              value: address?.streetNumber,
            },
            {
              label: t(Resources.Common.Address.OrientationNumber),
              value: address?.orientationNumber,
            },
            {
              label: t(Resources.Common.Address.Municipality),
              value: address?.municipality,
            },
          ]}
        />
      </ValuesBox>
    </Stack>
  );
};
